import PortfolioPage from './portfolio-page'
export default PortfolioPage
